import { render } from "./VerseLinks.vue?vue&type=template&id=14804e01&ts=true"
import script from "./VerseLinks.vue?vue&type=script&lang=ts"
export * from "./VerseLinks.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__